<template>
  <div class="downloads-tab p-4">
    <div
      v-for="(download, i) in event.event_downloads"
      :key="i"
      class="details-pane-table"
    >
      <div v-if="i > 0" class="row">
        <div class="col-12">
          <hr />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">Name:</div>
        <div class="col-8 col-value">{{ download.name }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">File Type:</div>
        <div class="col-8 col-value">
          <span>{{ download.type }}</span>
          <a
            :href="download.url"
            :data-file="download.file"
            class="download-link ml-2 btn-sm btn-primary"
            >Download</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true },
  },
};
</script>